
export default function aboutus() {
  return (
    <>
   <section id="about" className="about">
      <div className="container" data-aos="fade-up">
        <div className="row gx-0">
          <div className="col-lg-8 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
           <div className="content">
  <h3><i className="bi bi-code-slash"></i> Who I Am</h3>

  <h2>
    <i className="bi bi-person-check"></i> 
    Website Designing Company in Gurgaon
  </h2>

  <p>
    I am Pankaj Kumar Singh, providing professional website design and development services in Gurgaon since 2013. I have successfully completed 500+ website projects for businesses across different industries.
  </p>

  <p>
    As an independent website designing company in Gurgaon, I provide responsive website design, web development, SEO, and digital solutions focused on performance, usability, and clean user experience.
  </p>

  <p>
    Most consultations are conducted online for faster communication and convenience, while in-person meetings are also available when required.
  </p>

  <p>
    If you are looking for a reliable website designing company in Gurgaon, feel free to contact me for professional website solutions.
  </p>

  <p className="fh5co-sub to-animate">
    Website development is not just a job for me, it's my passion.
  </p>

  <div className="text-center text-lg-start">
    <a 
      href="/about-me" 
      className="btn-read-more d-inline-flex align-items-center justify-content-center align-self-center"
    >
      <span>Read More</span>
      <i className="bi bi-arrow-right"></i>
    </a>
  </div>
</div>
          </div>

          <div className="col-lg-4 d-flex align-items-center" data-aos="zoom-out" data-aos-delay="200">
            <img src={"../assets/img/ericssoncertificate.avif"} className="img-fluid" alt="Website Design Services in Gurugram" />
          </div>

        </div>
      </div>

    </section>
        <section id="values" className="values">

      <div className="container" data-aos="fade-up">

        <header className="section-header">
          <h2><i className="bi bi-code-square"></i> Core Services</h2>
          <p><i className="bi bi-code-slash"></i> Value-Added Service(VAS)</p>
        </header>

        <div className="row">

          <div className="col-lg-4" data-aos="fade-up" data-aos-delay="200">
            <div className="box">
              <img src="../assets/img/001.avif" className="img-fluid" alt="Web Apps Design" />
              <h3>Website Design</h3>
              <p>Whether its a One Page website or a full featured dynamic Website my focus is on quality, creative and easy to rank on search engine which is never compromised. I regularly use modern techniques which makes quickly growth.</p>
            </div>
          </div>

          <div className="col-lg-4 mt-4 mt-lg-0" data-aos="fade-up" data-aos-delay="400">
            <div className="box">
              <img src="../assets/img/002.avif" className="img-fluid" alt="Responsive Design" />
              <h3>Responsive Design</h3>
              <p>Designing user interfaces (UI) for mobile and tablet devices like iPhone, iPad and Android is one of the most challenging task for every website designer. Whether its Mobile Tablets or desktop i design website fully Responsive.</p>
            </div>
          </div>

          <div className="col-lg-4 mt-4 mt-lg-0" data-aos="fade-up" data-aos-delay="600">
            <div className="box">
              <img src="../assets/img/003.avif" className="img-fluid" alt="Website Development" />
              <h3>Website Development</h3>
              <p>So now you got a good design, making it fully functional including enquiries, newsletter & database. I have 10yr+ Experience in Front end development on responsive framework like Bootstrap5 & React JS</p>
            </div>
          </div>

        </div>

      </div>

    </section>
    </>
  );
}
